import React from 'react'

function TopBar(props) {
  return (
    <div className="TopBar">
    Salaam {props.user.name}!
    </div>
  )
}


export default TopBar
